module.exports = __webpack_public_path__ + "static/media/3BIANCA_Official_MENU-20533.aafc7357.jpg";